export default __webpack_public_path__ + "static/media/img5.7c9d916c.png";